// language=GraphQL
export const ALL_BARGAIN_CONFIGS_QUERY = `query Query($withTiers: Boolean = false) {
  bargainConfigs: ratioBargainConfigs {
    id
    active
    tiers @include(if: $withTiers) {
      id
      fromPrice
      discount
    }
    priceCap
    serviceCodePrefix
  }
}`

// language=GraphQL
export const SINGLE_BARGAIN_CONFIG_QUERY = `query Query($id: ID!, $withTiers: Boolean = false) {
  bargainConfig: ratioBargainConfig(id: $id) {
    id
    active
    tiers @include(if: $withTiers) {
      id
      fromPrice
      discount
    }
    priceCap
    serviceCodePrefix
  }
}`

// language=GraphQL
export const CREATE_BARGAIN_CONFIG_MUTATION = `
  mutation Mutation($input: CreateRatioBargainConfigInput, $withTiers: Boolean = false) {
    bargainConfig: createRatioBargainConfig(input: $input) {
      id
      active
      tiers @include(if: $withTiers) {
        id
        fromPrice
        discount
      }
      priceCap
      serviceCodePrefix
    }
  }`

// language=GraphQL
export const UPDATE_BARGAIN_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateRatioBargainConfigInput, $withTiers: Boolean = false) {
    bargainConfig: updateRatioBargainConfig(input: $input) {
      id
      active
      tiers @include(if: $withTiers) {
        id
        fromPrice
        discount
      }
      priceCap
      serviceCodePrefix
    }
  }`

// language=GraphQL
export const DELETE_BARGAIN_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteRatioBargainConfigInput) {
    deleteRatioBargainConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BARGAIN_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteRatioBargainConfigInput) {
    forceDeleteRatioBargainConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_BARGAIN_CONFIG_TIERS_MUTATION = `
  mutation Mutation($input: addRatioBargainConfigTiersInput) {
    addRatioBargainConfigTiers(input: $input) {
      id
      tierIds
    }
  }`

// language=GraphQL
export const REMOVE_BARGAIN_CONFIG_TIERS_MUTATION = `
  mutation Mutation($input: removeRatioBargainConfigTiersInput) {
    removeRatioBargainConfigTiers(input: $input) {
      id
      tierIds
    }
  }`

// language=GraphQL
export const CREATE_BARGAIN_CONFIG_TIERS_MUTATION = `
  mutation Mutation($input: createRatioBargainConfigTiersInput) {
    createRatioBargainConfigTiers(input: $input) {
      id
      tierIds
    }
  }`

// language=GraphQL
export const DELETE_BARGAIN_CONFIG_TIERS_MUTATION = `
  mutation Mutation($input: deleteRatioBargainConfigTiersInput) {
    deleteRatioBargainConfigTiers(input: $input) {
      id
      tierIds
    }
  }`

// language=GraphQL
export const UPDATE_BARGAIN_CONFIG_TIERS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioBargainConfigTiersOrderInput) {
    updateRatioBargainConfigTiersOrder(input: $input) {
      id
      tierIds
    }
  }`

// language=GraphQL
export const BARGAIN_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioConfigs: Boolean = false) {
  groupedDependents: ratioBargainConfigDependents(id: $id) {
    ratioConfigs @include(if: $withRatioConfigs) {
      id
    }
  }
}`
